import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const getHeaders = () => {
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token}`, Accept: 'application/json' };
};

const intermediateTestService = {
  async getIntermediateTests(courseId) {
    const res = await axios.get(`${API_BASE_URL}/intermediate-tests/course/${courseId}`, {
      headers: getHeaders(),
    });
    return res.data;
  },

  async getProjectWork(courseId, activityId = null) {
    const query = activityId ? `?activity_id=${activityId}` : '';
    const res = await axios.get(`${API_BASE_URL}/intermediate-tests/course/${courseId}${query}`, {
      headers: getHeaders(),
    });
    return res.data;
  },

  async listGroups(courseId, activityId = null) {
    const query = activityId ? `?activity_id=${activityId}` : '';
    const res = await axios.get(`${API_BASE_URL}/intermediate-tests/course/${courseId}/groups${query}`, {
      headers: getHeaders(),
    });
    return res.data;
  },

  async createGroup(courseId, name, activityId = null) {
    const res = await axios.post(
      `${API_BASE_URL}/intermediate-tests/course/${courseId}/groups`,
      { name, ...(activityId ? { activity_id: activityId } : {}) },
      { headers: getHeaders() }
    );
    return res.data;
  },

  async joinGroup(groupId) {
    const res = await axios.post(
      `${API_BASE_URL}/intermediate-tests/groups/${groupId}/join`,
      {},
      { headers: getHeaders() }
    );
    return res.data;
  },

  async createGithubRepo(groupId) {
    const res = await axios.post(
      `${API_BASE_URL}/intermediate-tests/groups/${groupId}/github-repo`,
      {},
      { headers: getHeaders() }
    );
    return res.data;
  },

  async saveGithubUsername(githubUsername) {
    const res = await axios.post(
      `${API_BASE_URL}/user/github-username`,
      { github_username: githubUsername },
      { headers: getHeaders() }
    );
    return res.data;
  },

  async submit(groupId, file = null, milestoneId = null, githubRepoUrl = null) {
    const formData = new FormData();
    if (file) formData.append('file', file);
    if (milestoneId) formData.append('milestone_id', milestoneId);
    if (githubRepoUrl) formData.append('github_repo_url', githubRepoUrl);

    const res = await axios.post(
      `${API_BASE_URL}/intermediate-tests/groups/${groupId}/submit`,
      file || milestoneId || githubRepoUrl ? formData : {},
      {
        headers: {
          ...getHeaders(),
          ...(file || milestoneId || githubRepoUrl ? { 'Content-Type': 'multipart/form-data' } : {}),
        },
      }
    );
    return res.data;
  },

  async confirmSubmission(submissionId) {
    const res = await axios.post(
      `${API_BASE_URL}/intermediate-tests/submissions/${submissionId}/confirm`,
      {},
      { headers: getHeaders() }
    );
    return res.data;
  },
};

export default intermediateTestService;
